import React, { useEffect, useState } from 'react';
import SaveDesignNameDialog from '../components/SaveDesignNameDialog/SaveDesignNameDialog';

interface Props {
    customerId: number | null;
    guestId: number | null;
}

declare global {
    interface Window {
        openDesignNameDialog: any;
    }
}

const DesignNameContainer: React.FC<Props> = (props) => {
    const { customerId, guestId } = props;
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        window.openDesignNameDialog = () => {
            setIsOpen(true);
        };

        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <SaveDesignNameDialog
            isOpen={isOpen}
            onClose={() => {
                setIsOpen(false);
            }}
            customerId={customerId}
            guestId={guestId}
        />
    );
};

export default DesignNameContainer;
